import { EntertainmentVideoReviewCard } from 'modules/entertainment-videos/components/entertainment-video-review-card';
import {
  EntertainmentVideoStatus,
  FullEntertainmentVideo
} from 'modules/entertainment-videos/types';
import React from 'react';
import { SubcampaignInfluencerProfile } from 'types';
import { __t, applyTranslations } from 'utils/language';
import DeliverableSubHeader from '../../deliverable-sub-header/DeliverableSubHeader';
import './deliverable-entertainment-video-for-review.scss';

applyTranslations(
  require('./deliverable-entertainment-video-for-review.i18n.json')
);

const MSG_KEY = 'deliverable_entertainment_video_for_review';

export function DeliverableEntertainmentVideoForReview({
  deliverableId,
  offerId,
  entertainmentVideos = [],
  isForBrand,
  influencerProfile
}: {
  deliverableId: number,
  offerId: number,
  entertainmentVideos: Array<FullEntertainmentVideo>,
  isForBrand?: boolean,
  influencerProfile: SubcampaignInfluencerProfile
}) {
  const filteredVideos = isForBrand
    ? entertainmentVideos.filter(
      (ev) => ev.entertainmentVideo.status !== EntertainmentVideoStatus.DRAFT
    )
    : entertainmentVideos;
  const isEmptyMode = filteredVideos.length === 0;

  return (
    <div>
      <DeliverableSubHeader
        directon={isEmptyMode ? 'row' : 'column'}
        title={__t(`${MSG_KEY}.title`)}
        emptyNote={isEmptyMode ? __t(`${MSG_KEY}.empty_note`) : undefined}
        instruction={
          isEmptyMode
            ? undefined
            : __t(
              `${MSG_KEY
              }.instruction${
                isForBrand ? '.brand' : '.influencer'}`
            )
        }
      />
      {!isEmptyMode && (
        <ul className="entertainment-video-list">
          {filteredVideos.map((fullVideo) => (
            <li key={fullVideo.entertainmentVideo.id}>
              <EntertainmentVideoReviewCard
                deliverableId={deliverableId}
                offerId={offerId}
                fullEntertainmentVideo={fullVideo}
                isForBrand={isForBrand}
                influencerProfile={influencerProfile}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
